import React from 'react';
import { Camera, Image, Palette, Share2, Smartphone, Users, Package, Truck, PartyPopper, Zap, Sparkles } from 'lucide-react';
import { Card } from './ui/card';

const Features = () => {
  const features = [
    {
      icon: <Image className="w-8 h-8" />,
      title: 'Unlimited Instant Images',
      description: 'Snap as many photos as you want throughout your event',
      highlight: false
    },
    {
      icon: <Palette className="w-8 h-8" />,
      title: 'Fully Customized',
      description: 'Custom logo, photo, text & color to match your event theme',
      highlight: false
    },
    {
      icon: <Camera className="w-8 h-8" />,
      title: 'PhotoStrips/Postcards',
      description: 'Instant prints in classic photo strip or postcard format',
      highlight: false
    },
    {
      icon: <PartyPopper className="w-8 h-8" />,
      title: 'Fun Array of Props',
      description: 'Hats, glasses, signs, and more for hilarious photos',
      highlight: false
    },
    {
      icon: <Share2 className="w-8 h-8" />,
      title: 'Online Access to Photos',
      description: 'Digital gallery with all event photos accessible anytime',
      highlight: false
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: 'Social Media Ready',
      description: 'Instant sharing to social platforms and GIF creation',
      highlight: false
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: 'Touchscreen Technology',
      description: 'Modern, intuitive interface for easy photo taking',
      highlight: false
    },
    {
      icon: <Package className="w-8 h-8" />,
      title: 'Custom Backdrops',
      description: 'Basic backdrops included or customize for an upgrade',
      highlight: false
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: 'Professional Attendant',
      description: 'Dapper photo booth attendant(s) to assist your guests',
      highlight: false
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: 'No Electricity Required!',
      description: 'Premium Digital booth is completely portable - setup anywhere without needing a power outlet. Perfect for outdoor venues, beaches, parks, and remote locations! (Print booth requires electric outlet)',
      highlight: true
    },
    {
      icon: <Truck className="w-8 h-8" />,
      title: 'Delivery & Setup',
      description: 'Complete setup and takedown within 20 miles included',
      highlight: false
    },
    {
      icon: <Sparkles className="w-8 h-8" />,
      title: 'Extra Upgrades & More',
      description: 'Time lapse video, personalized props, custom overlays, and additional premium options available',
      highlight: false
    }
  ];

  return (
    <section id="features" className="py-20 px-4 bg-cream-bg">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-logo-navy vintage-title mb-4">
            Everything You Need
          </h2>
          <p className="text-xl text-logo-navy-light max-w-2xl mx-auto">
            Lasting memories and a lot of FUN with our complete photo booth experience
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <Card 
              key={index}
              className={`p-6 border-2 transition-all hover:shadow-lg group relative overflow-hidden ${
                feature.highlight 
                  ? 'bg-gradient-to-br from-accent-warm/10 to-logo-teal/10 border-accent-warm shadow-xl ring-2 ring-accent-warm/50' 
                  : 'bg-white border-logo-teal/20 hover:border-logo-teal'
              }`}
            >
              {feature.highlight && (
                <>
                  <div className="absolute top-0 right-0 bg-accent-warm text-white px-3 py-1 text-xs font-bold transform rotate-12 translate-x-2 -translate-y-1">
                    ⚡ SPECIAL
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-br from-accent-warm/5 to-transparent pointer-events-none"></div>
                </>
              )}
              <div className="flex items-start gap-4 relative z-10">
                <div className={`p-3 rounded-lg transition-colors ${
                  feature.highlight
                    ? 'bg-accent-warm text-white'
                    : 'bg-logo-teal-light text-logo-teal group-hover:bg-logo-teal group-hover:text-white'
                }`}>
                  {feature.icon}
                </div>
                <div>
                  <h3 className={`text-lg font-bold mb-2 ${
                    feature.highlight ? 'text-accent-warm' : 'text-logo-navy'
                  }`}>
                    {feature.title}
                  </h3>
                  <p className="text-logo-navy-light text-sm">
                    {feature.description}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;